import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    Button,
    Card,
    CardBody,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Typography
} from "@material-tailwind/react";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {getAgentServiceDocumentation} from "../../services/service/service";
import {ServiceDocumentGrid} from "./agent_service_document-grid";
import {BsBoxArrowDownRight} from "react-icons/bs";
import {ServiceDetailForm} from "./service_detail_form";
import {ServiceContext} from "./service_context";

export function PersonServiceCheckForm() {
  const {
    service,
    modalOpen,
    setModalOpen,
    setStep,
    show,
    setShow
  } = useContext(ServiceContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [allAccepted, setAllAccepted] = useState(false);

  const [serviceDocumentations, setServiceDocumentations] = useState([])

  useEffect(() => {
    async function getData() {
      const result = await getAgentServiceDocumentation(service.id);
      if (result.status === 200) {
        const {serviceDocumentationList} = result.data;
        setServiceDocumentations(serviceDocumentationList || []);
        if (serviceDocumentationList?.length > 0) {
          const all_accepted = serviceDocumentationList.every(obj => obj.status === "accepted")
          setAllAccepted(all_accepted);
        } else {
          setAllAccepted(true);
        }
      }
    }

    if (service?.id) {
      getData()
    }
  }, [service]);

  const handleShow = (value) => {
    setShow(show === value ? 0 : value);
  }

  if (service) {
    return (
      <>
        <Dialog size="xl" open={modalOpen} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
                className="max-h-screen overflow-y-scroll mt-20 mb-20">
          <DialogHeader className="border-b">
            <Typography>
              {"درخواست خدمات" + " - " + service.agent_name + " " + service.agent_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          </DialogHeader>

          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">
            <Card>
              <CardBody className="flex flex-col">
                {serviceDocumentations.length > 0 &&
                  <Accordion open={show === 1} className="mb-4">
                    <AccordionHeader
                      className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
                      onClick={() => handleShow(1)}>
                      <Typography className="flex w-full font-bold text-lg">
                        مدارک مورد نیاز
                      </Typography>
                      <BsBoxArrowDownRight className="flex"/>
                    </AccordionHeader>

                    <AccordionBody>
                      <ServiceDocumentGrid serviceDocuments={serviceDocumentations}/>
                    </AccordionBody>

                  </Accordion>
                }

                <Accordion open={show === 2} className="mb-4">
                  <AccordionHeader
                    className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
                    onClick={() => handleShow(2)}>
                    <Typography className="flex w-full font-bold text-lg">
                      قیمت و اطلاعات خدمات
                    </Typography>
                    <BsBoxArrowDownRight className="flex"/>
                  </AccordionHeader>

                  <AccordionBody className="overflow-y-scroll">
                    <ServiceDetailForm/>
                  </AccordionBody>

                </Accordion>

              </CardBody>
            </Card>

          </DialogBody>

          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={() => {
              handleOpen()
            }}>
              <span>بستن</span>
            </Button>
            {(service.status === "waiting" || (service.price && allAccepted && service.status !== "payment")) &&
              <Button variant="gradient" color="gray" onClick={() => {
                setStep("invoice")
              }} className="ml-1">
                <span>پرداخت</span>
              </Button>}
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}